<template>
    <ImpedimentContainer
        title="DB-Sordo-Ciego"
    >
        <p><b>El estudiante presenta:</b></p>
        <TreeOptions
            v-model="optionsTree"
            :is-disabled="isDisabled"
            :show-error="showErrors && !isValid"
        />
        <p class="disclaimer__text">
            En esta categoría se incluirán a todos los estudiantes que presenten sordoceguera, aunque muestren otras condiciones como autismo, discapacidad intelectual, problemas emocionales, problemas de salud e impedimentos ortopédicos.
        </p>
    </ImpedimentContainer>
</template>
  
<script>
import TreeOptions from './options/TreeOptions.vue';
import ImpedimentMixin from './common/ImpedimentMixin';
import ImpedimentContainer from './common/ImpedimentContainer';

export default {
    name: 'SordoCiego',
    mixins: [ImpedimentMixin],
    components: {
        TreeOptions,
        ImpedimentContainer
    },
    data: () => ({
        showErrors: false,
    }),
    methods: {
        validate() {
            this.showErrors = true;
            return this.isValid;
        }
    },
    computed: {
        isValid() {
            return this.isValidOptionsSelection;
        }
    },
}
</script>

<style scoped>
.disclaimer__text {
    margin-top: 30px;
    font-weight: bold;
    font-style: italic;
}
</style>